(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mishu-favoritos"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MQ=window.matchMedia('(min-width:990px)');
  function init(sec){
    if(sec.__mhfav)return;sec.__mhfav=1;
    var track=sec.querySelector('.mh-fav-track'),nav=sec.querySelector('.mh-fav-nav'),slides=sec.querySelectorAll('.mh-fav-slide');
    if(!track||!nav)return;
    var cur=0,lastPer=per();
    function per(){return window.matchMedia('(min-width:1400px)').matches?4:3}
    function max(){return Math.max(0,slides.length-per())}
    window.addEventListener('resize',function(){var p=per();if(p!==lastPer){lastPer=p;cur=0;apply()}});function apply(){track.style.translate=MQ.matches?(-cur*100)+'% 0':''}
    function place(){
      var img=sec.querySelector('.mh-fav-img');if(!img||!MQ.matches)return;
      var s=sec.getBoundingClientRect(),r=img.getBoundingClientRect();
      nav.style.setProperty('--top',(r.top-s.top+r.height/2-22)+'px');
    }
    nav.addEventListener('click',function(e){
      if(!MQ.matches)return;
      var b=e.target.closest('.mh-fav-arrow');if(!b)return;
      e.stopPropagation();e.preventDefault();
      cur+=b.classList.contains('mh-fav-next')?1:-1;
      if(cur>max())cur=0;if(cur<0)cur=max();
      apply();
    },true);
    function onChange(){cur=0;apply();place()}
    if(MQ.addEventListener)MQ.addEventListener('change',onChange);else MQ.addListener(onChange);
    window.addEventListener('resize',place);window.addEventListener('load',place);
    sec.querySelectorAll('img').forEach(function(i){if(!i.complete)i.addEventListener('load',place)});
    place();
  }
  function addHover(sec){
    sec.querySelectorAll('.mh-fav-card').forEach(function(a){
      var box=a.querySelector('.mh-fav-img');if(!box||box.querySelector('.mh-fav-img-hover'))return;
      var m=(a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/);if(!m)return;
      fetch('/products/'+m[1]+'.js').then(function(r){return r.json()}).then(function(p){
        if(!p||!p.images||p.images.length<2)return;
        var src=p.images[1];if(typeof src!=='string')src=src.src;
        var h=new Image();h.className='mh-fav-img-hover';h.alt='';h.decoding='async';
        h.src=src+(src.indexOf('?')>-1?'&':'?')+'width=900';
        box.appendChild(h);
      }).catch(function(){});
    });
  }
  function run(){document.querySelectorAll('.mh-favoritos').forEach(function(s){init(s);addHover(s)})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

  } catch(e) { console.error(e); }
})();
})();
